export const initialFormData = {
  supplyType: "O",
  subSupplyType: "1",
  subSupplyDesc: "",
  docType: "INV",
  doc_no: "",
  doc_date: new Date().toISOString().split("T")[0],
  GST : "",
  Company_Name_E: "",
  millname: "",
  milladdress: "",
  millcityname: "",
  millpincode: 0,
  actFromStateCode: 0,
  fromStateCode: 0,
  BillToGst: "",
  BillToName: "",
  ShippTo: "",
  Address_E: "",
  city_name_e: "",
  ShipToPinCode: 0,
  actToStateCode: 0,
  toStateCode: 0,
  totalValue: 0,
  CGSTAmount: 0,
  SGSTAmount: 0,
  IGSTAmount: 0,
  cessValue: 0,
  totInvValue: 0,
  transporterId: "",
  transporterName: "",
  transDocNo: "",
  transMode: "1",
  Distance: "",
  transDocDate: "",
  LORRYNO: "",
  vehicleType: "R",
  System_Name_E: "",
  HSN: 0,
  NETQNTL: 0,
  qtyUnit: "QTL",
  CGSTRate: 0,
  SGSTRate: 0,
  IGSTRate: 3,
  cessRate: 0,
  cessAdvol: 0,
  TaxableAmount: 0,
  year:"",
  tranType:"",
  millstatename:"",
  State_Name:"",
  cgstSgstRate:"Y",
  igstRate:"Y",
  cessAdvolRate:"Y",
  cessNonAdvolRate:"Y",
  otherAmount:0.0,
  companyState:"",
  productDesc:"",
  fromGstin:"",
};
